/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app/app.config';
import { App } from './app/app/app';

bootstrapApplication(App, appConfig).catch(() => {});
